import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg component

// 添加iconfont图标
const s = document.createElement('script')
s.type = 'text/javascript'
s.src = '//at.alicdn.com/t/font_2748428_ny6g865xqa.js'
document.body.appendChild(s)

// register globally
Vue.component('SvgIcon', SvgIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)



// WEBPACK FOOTER //
// ./src/icons/index.js